import { z } from 'zod'
import type { AppCatalogProductCategory } from '../../models/AppCatalogProductCategory'
import { SlimModelDTO, mapDTOToSlimModel, mapSlimModelToDTO } from '~/domain/shared/slim/gateways/DTOs/SlimModelDTO'

export const AppCatalogProductCategoryDTO = z.object({
  id: z.number(),
  next_category: SlimModelDTO.nullish(),
  name: z.string().nullish(),
  position: z.number().nullish(),
  preparation_time: z.number().nullish()
})

export type AppCatalogProductCategoryDTO = z.infer<typeof AppCatalogProductCategoryDTO>

export function mapAppCatalogProductCategoryToDTO (model: AppCatalogProductCategory): AppCatalogProductCategoryDTO {
  return {
    id: model.id,
    next_category: model.nextCategory ? mapSlimModelToDTO(model.nextCategory) : undefined,
    name: model.name,
    position: model.position,
    preparation_time: model.preparationTimeMinutes
  }
}

export function mapDTOToAppCatalogProductCategory (dto: AppCatalogProductCategoryDTO): AppCatalogProductCategory {
  return {
    id: dto.id,
    nextCategory: dto.next_category ? mapDTOToSlimModel(dto.next_category) : undefined,
    name: dto.name ?? undefined,
    position: dto.position ?? undefined,
    preparationTimeMinutes: dto.preparation_time ?? undefined
  }
}
